import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { Children, cloneElement } from 'react';

function Group(props) {
  var children = props.children,
      style = props.style,
      inputFocus = props.inputFocus,
      other = _objectWithoutProperties(props, ["children", "style", "inputFocus"]);

  return Children.toArray(children).map(function (child, i) {
    if (typeof child === 'string') {
      return (
        /*#__PURE__*/
        React.createElement("span", {
          key: i
        }, child)
      );
    }

    return (
      /*#__PURE__*/
      cloneElement(child, other)
    );
  });
}

export default Group;